<template>
  <section>
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <!-- <span slot="oilAccountTypeTip">
        <span
          class="primary cur"
          style="margin-left: 16px"
          @click="queryGasStation"
          >查询油站</span
        >
      </span> -->
      <span slot="chart">
        <IntelligenceChart
          ref="intelligenceChart"
          :chartData="chartData"
          :dispatchInfo="dispatchInfo"
          :getFeeParams="getFeeParams"
        />
      </span>
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </section>
</template>

<script>
import {
  isExist,
} from '@qx/utils/index';
import IntelligenceChart from './chart';
export default {
  components: {
    IntelligenceChart,
  },
  props: {
    chartData: {
      type: Object,
      default: () => ({}),
    },
    getFeeParams: {
      type: Object,
      default: () => ({}),
    },
    paymentWay: {
      type: Number,
      default: 0,
    },
  },
  data () {
    return {
      dispatchInfo: {},
      otherFormData: {},
      baseForm: {
        form: [
          {
            label: '分配油来源',
            value: 'oilAccountType',
            type: 'select',
            placeholder: '请选择分配油来源',
            default: '1',
            options: [
              {
                label: '本车队定点油',
                value: '1',
              },
              {
                label: '找油-无发票',
                value: '2',
              },
              {
                label: '找油-有发票',
                value: '3',
              },
            ],
          },
          {
            label: '空载油耗',
            value: 'emptyOilCostPer',
            type: 'input',
            unit: '（升/百公里）',
          },
          {
            label: '载重油耗',
            value: 'oilCostPer',
            type: 'input',
            unit: '（升/百公里）',
          },
          {
            label: '单公里路桥',
            value: 'pontagePer',
            type: 'input',
            unit: '（元/公里）',
          },
          {
            label: '空载距离',
            value: 'runWay',
            type: 'input',
            unit: 'KM',
            onChange: (val) => {
              this.$emit('onRunWayChange', parseInt(val * 1000, 10));
            },
          },
          {
            value: 'chart',
            allCustom: true,
          },
        ],
        rules: {
          oilAccountType: [
            { required: true, message: '请选择分配油来源', trigger: 'blur' },
          ],
          emptyOilCostPer: [
            { required: true, message: '请输入空载油耗', trigger: 'blur' },
          ],
          oilCostPer: [
            { required: true, message: '请输入载重油耗', trigger: 'blur' },
          ],
          pontagePer: [
            { required: true, message: '请输入单公里路桥', trigger: 'blur' },
          ],
          runWay: [
            { required: true, message: '请输入空载距离', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      // console.log('智能模式参数', this.sub());
    },
    setFormData (options = {}) {
      this.$refs.baseForm.setVal('emptyOilCostPer', options.emptyOilCostPer || '0');
      this.$refs.baseForm.setVal('oilCostPer', options.oilCostPer || '0');
      this.$refs.baseForm.setVal('pontagePer', options.pontagePer || '0');
      this.$refs.baseForm.setVal('runWay', options.runWay || '0');
    },
    async setCarSelfFee (data) {
      if (isExist(data)) {
        this.countTitleShow = false;
        // 路桥费
        this.dispatchInfo.pontage = isExist(data.pontageFee) ? (Number(data.pontageFee) / 100).toFixed(2) : this.dispatchInfo.pontage;
        // 主驾驶补贴
        this.dispatchInfo.userSubsidy = isExist(data.carDriverSubsidy) ? (Number(data.carDriverSubsidy) / 100).toFixed(2) : this.dispatchInfo.userSubsidy;
        // 副驾驶补贴
        this.dispatchInfo.copilotSubsidy = isExist(data.copilotSubsidy) ? (Number(data.copilotSubsidy) / 100).toFixed(2) : this.dispatchInfo.copilotSubsidy;
        // 切换司机补贴
        this.dispatchInfo.driverSwitchSubsidy = isExist(data.driverSwitchSubsidy) ? (Number(data.driverSwitchSubsidy) / 100).toFixed(2) : this.dispatchInfo.driverSwitchSubsidy;
        this.dispatchInfo.subsidyTotal = Number(this.dispatchInfo.userSubsidy) + Number(this.dispatchInfo.copilotSubsidy) + Number(this.dispatchInfo.driverSwitchSubsidy);
        this.dispatchInfo.oilPrice = Number((Number(data.oilPrice) / 100).toFixed(2));
        // 实体油卡
        this.dispatchInfo.oilSelfEntity = isExist(data.oilSelfTotal) ? Number((data.oilSelfTotal).toFixed(2)) : 0;
        // 虚拟油卡 默认全部为虚拟油卡
        this.dispatchInfo.oilSelfVirtual = isExist(this.dispatchInfo.oilSelfVirtual) ? this.dispatchInfo.oilSelfVirtual : 0;
        // 虚拟油量
        this.dispatchInfo.oilLitreVirtual = isExist(this.dispatchInfo.oilLitreVirtual) ? this.dispatchInfo.oilLitreVirtual : 0;
        // 实体油量
        this.dispatchInfo.oilLitreEntity = (data.oilTotal).toFixed(2);
        if (this.dispatchInfo.oilLitreEntity - this.dispatchInfo.oilLitreVirtual > 0) {
          this.dispatchInfo.oilLitreEntity = Number((Number(this.dispatchInfo.oilLitreEntity) - Number(this.dispatchInfo.oilLitreVirtual)).toFixed(2));
        } else {
          this.dispatchInfo.oilLitreEntity = 0;
        }
        if (!isExist(data.oilSelfTotal)) {
          // 实体油费
          this.dispatchInfo.oilSelfEntity = Number((Number(this.dispatchInfo.oilLitreEntity) * Number(this.dispatchInfo.oilPrice)).toFixed(2));
          // 重新计算 油费和预估成本
          this.dispatchInfo.oilSelfTotal = Number(Number(this.dispatchInfo.oilSelfEntity) + Number(this.dispatchInfo.oilSelfVirtual)).toFixed(2);
        } else {
          this.dispatchInfo.oilSelfTotal = data.oilSelfTotal;
        }
        if (isExist(data.estFee)) {
          this.dispatchInfo.estFee = data.estFee;
        } else {
          this.dispatchInfo.estFee = Number(this.dispatchInfo.oilSelfTotal) + Number(this.dispatchInfo.userSubsidy) + Number(this.dispatchInfo.copilotSubsidy) + Number(this.dispatchInfo.pontage);
          this.dispatchInfo.estFee = Number(Number((this.dispatchInfo.estFee) + Number(this.dispatchInfo.driverSwitchSubsidy)).toFixed(2));
        }
        this.dispatchInfo.oilLitreTotal = Number((data.oilTotal).toFixed(2)); // 总耗油量
        this.dispatchInfo.runWay = Number((Number(data.emptyDistance) / 1000).toFixed(2)); // 空驶距离

        this.dispatchInfo.carDriverSubsidyDate = data.carDriverSubsidyDate; // 主驾补贴
        this.dispatchInfo.copilotSubsidyDate = data.copilotSubsidyDate; // 副驾补贴
        this.dispatchInfo.driverSubsidyDays = data.driverSubsidyDays; // 各司机补贴天数
        this.dispatchInfo.sysOilPrice = Number((Number(data.oilPrice) / 100).toFixed(2)); // 油单价

        this.$refs.intelligenceChart.setChartData(this.dispatchInfo);
      }
    },
    // queryGasStation () {
    //   this.$message({
    //     type: 'info',
    //     message: '开发中',
    //   });
    // },
    async handleSubData (cache) {
      let formData = null;
      let formDataIntelligenceChart = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        // 这里处理的格式必须和详情接口返回的一样
        if (this.$refs.contractChart) {
          this.otherFormData.contractChart = this.$refs.contractChart.getFormsValue();
        }
        if (this.$refs.intelligenceChart) {
          formDataIntelligenceChart = await this.$refs.intelligenceChart.sub();
        }
        formData = {
          ...formData,
          ...this.otherFormData,
          ...formDataIntelligenceChart,
        };
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async getVal () {
      const formData = await this.$refs.baseForm.getVal();
      return formData;
    },
    async sub () {
      let formData = await this.handleSubData();
      return formData;
    },
    // 计算费用
    getFee (data) {
      this.$refs.intelligenceChart.getFee(data);
    },
  },
  watch: {
    paymentWay: {
      immediate: true,
      handler (newValue, oldValue) {
        const requiredValue = newValue === '1';
        if (newValue === '1') {
          // 当前的智能模式
        } else {
          // 如果不是当前的智能模式
        }
        this.setFormRuleAttr({
          rules: this.baseForm.rules,
          attr: 'required',
          value: requiredValue,
        });
      },
    },
  },
};
</script>

<style>
</style>
